import { render, staticRenderFns } from "./parallel_diff_view.vue?vue&type=template&id=6a62d486&"
import script from "./parallel_diff_view.vue?vue&type=script&lang=js&"
export * from "./parallel_diff_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports